import { WarningIcon, Typography } from "@packages/ds";
import styled from "styled-components";

export const Warning = styled(WarningIcon)`
  fill: var(--icon-gold-fill, var(--gold));
`;

export const LiveTag = styled.span`
  padding: 1px 8px;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: var(--tag-color-primary-600-color, var(--color-primary-600));
  background-color: var(
    --tag-color-primary-100-background-color,
    var(--color-primary-100)
  );
  border-radius: 2px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProjectTitle = styled(Typography.BodyText)`
  margin: 12px 0;
`;

export const LinkWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin: 18px 0 25px 0;
`;

export const WarningWrapper = styled.div`
  gap: 8px;
  display: flex;
  margin-top: 20px;
`;

export const CautionText = styled(Typography.Label)`
  line-height: 19px;
`;
